module.exports = __webpack_public_path__ + "static/media/logo.b59bf8a4.png";